import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  filtersBar: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: 10,
  },
  tabs: {
    marginBottom: 20,
  },
  label: {
    marginRight: 20,
    fontSize: 15,
    lineHeight: 1,
    fontWeight: 600,
    color: '#fff',
  },
  value: {
    fontSize: 15,
    lineHeight: 1,
    fontWeight: 400,
    color: '#fff',
  },
  btn: {
    marginLeft: 13,
    background: '#F0F3F7',
    '&:hover': {
      background: '#dfe6ee',
    },
  },
  icon: {
    color: theme.custom.darkBlue,
  },
}));
